module.exports = __webpack_public_path__ + "img/activities-2.530b76bd.jpg";